export enum WorkflowState {
  IDLE = "idle",
  SYNKPASS = "synkpass",
  SYNKCRYPT = "synkcrypt",
  SYNKSMAH = "synksmash",
  SYNKSWAP = "synkswap",
  COMPLETED = "completed",
}

export type WorkflowType =
  | "file_encryption"
  | "password_generation"
  | "crypto_swap";

export interface ChatMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
  timestamp: number;
  attachedFile?: File | null; // Add optional file attachment to each message
}

export interface WorkflowContext {
  type: WorkflowType;
  userMessage: string;
  step: number;
  file?: File;
  encryptedFile?: File;
  targetId?: string;
  username?: string;
  integrationUrl?: string;
}

export interface SynkPassResponse {
  success: boolean;
  password: string;
  targetId: string;
}

export interface SynkCryptResponse {
  success: boolean;
  encryptedFile: File;
  integrationUrl: string;
}

export interface SynkSmashResponse {
  success: boolean;
  shareUrl: string;
  fileId: string;
}

export interface SynkSwapResponse {
  success: boolean;
  transactionHash: string;
  amount: string;
}
